import { render, staticRenderFns } from "./QrScanner.vue?vue&type=template&id=84ccbb18"
import script from "./QrScanner.vue?vue&type=script&lang=js"
export * from "./QrScanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports